import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularDivident: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_divident"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="divident icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.7498 1.99756C9.67751 1.99756 7.99756 3.67751 7.99756 5.74984C7.99756 7.56538 9.28697 9.07977 11 9.42719V11.4998H7.75C6.50736 11.4998 5.5 12.5072 5.5 13.7498V14.5752C3.78819 14.9236 2.5 16.4374 2.5 18.2521C2.5 20.3244 4.17996 22.0044 6.25228 22.0044C8.32461 22.0044 10.0046 20.3244 10.0046 18.2521C10.0046 16.4358 8.71409 14.9209 7 14.5743V13.7498C7 13.3356 7.33579 12.9998 7.75 12.9998H15.75C16.1642 12.9998 16.5 13.3356 16.5 13.7498V14.5752C14.7882 14.9236 13.5 16.4374 13.5 18.2521C13.5 20.3244 15.18 22.0044 17.2523 22.0044C19.3246 22.0044 21.0046 20.3244 21.0046 18.2521C21.0046 16.4358 19.7141 14.9209 18 14.5743V13.7498C18 12.5072 16.9926 11.4998 15.75 11.4998H12.5V9.42713C14.2129 9.07958 15.5021 7.56527 15.5021 5.74984C15.5021 3.67751 13.8222 1.99756 11.7498 1.99756ZM9.49756 5.74984C9.49756 4.50594 10.5059 3.49756 11.7498 3.49756C12.9937 3.49756 14.0021 4.50594 14.0021 5.74984C14.0021 6.99375 12.9937 8.00213 11.7498 8.00213C10.5059 8.00213 9.49756 6.99375 9.49756 5.74984ZM4 18.2521C4 17.0082 5.00838 15.9998 6.25228 15.9998C7.49619 15.9998 8.50457 17.0082 8.50457 18.2521C8.50457 19.496 7.49619 20.5044 6.25228 20.5044C5.00838 20.5044 4 19.496 4 18.2521ZM17.2523 15.9998C18.4962 15.9998 19.5046 17.0082 19.5046 18.2521C19.5046 19.496 18.4962 20.5044 17.2523 20.5044C16.0084 20.5044 15 19.496 15 18.2521C15 17.0082 16.0084 15.9998 17.2523 15.9998Z" />
      </svg>
    </span>
  );
};

export { RegularDivident };
